<template>
   <!-- Footer -->
    <v-footer app 
    :style="{ background: theme.background, color: theme.color}"
    >
    <div class="px-xs-4 px-sm-4 px-md-16" style="width: 100%; text-align: center;">
      <v-row >
        <v-col cols="12" md="12" class="px-xs-4 px-sm-4 px-md-16">
          <span>&copy; 2025 NB Accounting</span>
        </v-col>
      </v-row>
    </div>
    </v-footer>
</template>

<script setup>
import { ref, computed, onMounted, inject   } from "vue"
import { useThemeStore } from "@/store/auth"
const themeStore = useThemeStore()
const theme = computed(() => themeStore.themeStyles)
// const theme = localStorage.getItem('currentTheme');

// import { useThemeStore } from "@/store/auth"
// const themeStore = useThemeStore()  
// function selectTheme(theme) {
//   // update switches (only one active at a time)
//   lightSwitch.value = theme === 'light'
//   darkSwitch.value = theme === 'dark'
//   hybridSwitch.value = theme === 'hybrid'

//   // update the theme in Pinia store
//   themeStore.setTheme(theme) 
// }
</script>